/**
 * Formats an enterprise name for display in legal text.
 * Replaces underscores and dashes with spaces, then converts to title case.
 */
export function formatEnterpriseName(name: string): string {
  return name
    .replace(/[-_]/g, ' ')
    .toLowerCase()
    .replace(/(^|\s)\w/g, (char) => char.toUpperCase());
}
